import { main } from '../constants';

export default {
  updateCredentials: payload => ({ type: main.UPDATE_CREDENTIALS, data: payload }),
  updateLastActivity: payload => ({ type: main.UPDATE_LAST_ACTIVITY, data: payload }),
  logout: () => ({ type: main.LOGOUT }),
  updateLoadingMessage: payload => ({ type: main.UPDATE_LOADING_MESSAGE, data: payload }),
  updateColorScheme: payload => ({ type: main.UPDATE_COLOR_SCHEME, data: payload }),
  updateWindowDimensions: payload => ({ type: main.UPDATE_WINDOW_DIMENSIONS, data: payload }),
  updateScrollbarWidth: payload => ({ type: main.UPDATE_SCROLLBAR_WIDTH, data: payload }),
};